import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'certificado', namespaced: true })

export default mystore
